import React from "react";
import { Link } from "react-router-dom";
// import styled from "styled-components";
import { logoImage, logo2Image } from "../../../assets/images";
import "./index.scss";

export default function BrandLogo({ anotherLogo }) {
	return (
		// <LogoContainer>
		<Link to="/" className="brandLogoContainer">
			<img
				src={!anotherLogo ? logoImage : logo2Image}
				alt="Logo"
				className="brandLogoContainer_brandLogo"
			/>
		</Link>
		// </LogoContainer>
	);
}

// const LogoContainer = styled.span`
// 	.brandLogoContainer {
// 		@media (max-width: 768px) {
// 			&_brandLogo {
// 				width: 70%;
// 			}
// 		}
// 	}
// `;
